export default __webpack_public_path__ + "static/media/refectori-espleni-01.9d1d8071.jpg";